import React from 'react'

const Footer = () => {
  return (
    <footer className="w3-container w3-black w3-padding-16">
    <p>
      Powered by{" "}
      <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">
        w3.css
      </a>
    </p>
  </footer>
  )
}

export default Footer